<template>
	<v-bottom-navigation
		v-clickoutside="() => expandido = false"
		v-model="bottomNav"
		app
		dark
		class="secondary flex-wrap bottom-nav"
		style="transition: height 0.25s;"
		:style="{ height: `${navHeight}px` }"
	>
		<v-btn
			v-for="item in itensMenuIniciais"
			:key="item.nome"
			:to="item.path"
			@click="() => {
				item.action && item.action()
				expandido = false
			}"
			class="bottom-nav__button"
			color="secondary"
		>
			<span>{{ item.nome }}</span>
			<v-badge
				color="orange"
				bottom
				offset-y="20"
				offset-x="-2"
				content="!"
				:value="temConteudoNovoItem(item)"
			>
				<v-icon> {{ item.icone }} </v-icon>
			</v-badge>
		</v-btn>

		<v-btn
			v-if="authModule.éVisitante"
			class="bottom-nav__button"
			@click="authModule.logout"
			key="sair-visitante"
			color="secondary"
		>
			<span> Sair </span>
			<v-icon> mdi-logout-variant </v-icon>
		</v-btn>

		<v-btn
			v-else
			class="bottom-nav__button"
			:class="{ 'order-last': $vuetify.breakpoint.smAndUp }"
			@click="() => expandido = !expandido"
			key="expandir"
			color="secondary"
		>
			<span> {{ !expandido ? 'Mais' : 'Menos' }} </span>
			<v-icon> {{ !expandido ? 'mdi-chevron-up' : 'mdi-chevron-down' }} </v-icon>
		</v-btn>

		<template v-if="expandido">
			<v-btn
				v-for="item in itensMenuAdicionais"
				:key="item.nome"
				:to="item.path"
				@click="() => expandido = false"
				class="bottom-nav__button"
				color="secondary"
			>
				<span> {{ item.nome }} </span>
				<v-icon> {{ item.icone }} </v-icon>
			</v-btn>

			<v-btn
				class="bottom-nav__button"
				@click="() => {
					authModule.logout()
					expandido = false
				}"
				key="Sair"
				color="secondary"
			>
				<span> Sair </span>
				<v-icon> mdi-logout-variant </v-icon>
			</v-btn>

		</template>
	</v-bottom-navigation>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue'
import { authModule, application } from '@/store'
import clickOutside from '@/components/directives/click-outside'
import { useVuetify } from '@/composables/vuetify'

const vClickoutside = clickOutside

const vuetify = useVuetify()

const bottomNav = ref(null)
const expandido = ref(false)

const itensMenuIniciais = computed(() => authModule.activeMenus.slice(0, 3))

const itensMenuAdicionais = computed(() => authModule.activeMenus.slice(3))

const navHeight = computed(() => !expandido.value || vuetify.breakpoint.smAndUp
	? 56
	: 56 + Math.ceil((itensMenuAdicionais.value.length + 1) / 4) * 56)

watch(navHeight, (altura) => {
	vuetify.application.bottom = altura
}, { immediate: true })

function temConteudoNovoItem(item: typeof authModule['activeMenus'][0]) {
	if (item.nome === 'Home') return application.temNovidades
	return false
}
</script>

<style scoped>

.bottom-nav__button {
	height: 56px !important;
	width: 80px; 
}

</style>
